import React, { useState, useEffect } from 'react';
import { Modal, Button, Icon } from 'antd';
import './index.less'

export default React.memo(({ src, alt, imgVisible, onModalChange }) => {
  const [visible, setVisible] = useState(false);
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setVisible(true)
  }, [imgVisible])



  // 重置状态
  const resetState = () => {
    setScale(1);
    setRotate(0);
    setPosition({ x: 0, y: 0 });
  };

  // 关闭预览
  const handleClose = () => {
    setVisible(false);
    setTimeout(resetState, 300);
    onModalChange && onModalChange()
  };

  // 滚轮缩放
  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.2 : 0.2;
    setScale(prev => Math.max(0.5, Math.min(prev + delta, 3)));
  };

  // 拖拽开始
  const handleMouseDown = (e) => {
    if (scale <= 1) return;
    setIsDragging(true);
    setStartPos({ x: e.clientX - position.x, y: e.clientY - position.y });
    e.preventDefault();
  };

  // 拖拽移动
  const handleMouseMove = (e) => {
    if (!isDragging || scale <= 1) return;
    setPosition({
      x: e.clientX - startPos.x,
      y: e.clientY - startPos.y
    });
  };

  // 拖拽结束
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // 旋转图片
  const rotateImage = (angle) => {
    setRotate(prev => (prev + angle) % 360);
  };

  // 快捷键支持
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!visible) return;
      if (e.key === 'Escape') handleClose();
      if (e.key === 'ArrowLeft') rotateImage(-90);
      if (e.key === 'ArrowRight') rotateImage(90);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [visible]);
  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width="100%"
      wrapClassName="antd-style-image-modal"
      bodyStyle={{
        padding: 0,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      }}
      closable={false}
      maskClosable
      keyboard
    >
      <div className="antd-style-toolbar">
        <Button.Group>
          <Button type="text" onClick={() => rotateImage(90)}>
            <Icon type="redo" style={{ color: 'rgba(255, 255, 255, 0.85)' }} />
          </Button>
          <Button type="text" onClick={resetState}>
            <Icon type="sync" style={{ color: 'rgba(255, 255, 255, 0.85)' }} />
          </Button>
          <Button type="text" onClick={() => setScale(prev => Math.min(prev + 0.5, 3))}>
            <Icon type="zoom-in" style={{ color: 'rgba(255, 255, 255, 0.85)' }} />
          </Button>
          <Button type="text" onClick={() => setScale(prev => Math.max(prev - 0.5, 0.5))}>
            <Icon type="zoom-out" style={{ color: 'rgba(255, 255, 255, 0.85)' }} />
          </Button>
        </Button.Group>
        <Button
          type="text"
          onClick={handleClose}
        // style={{ position: 'absolute', right: 10, top: 10 }}
        >
          <Icon type="close" style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: 20 }} />
        </Button>

      </div>
      <div
        className="image-viewer-container"
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        style={{
          cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'zoom-out'
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            transform: `scale(${scale}) rotate(${rotate}deg)`,
            transition: isDragging ? 'none' : 'transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain'
          }}
        />
      </div>
    </Modal>
  );
});
